export default "__VITE_ASSET__1dfa80d9__"